/**
 * DEFUNCT
 */

import { define } from 'wicked-elements'
import ScrollBooster from 'scrollbooster'

define('[data-component~="scrollbooster"]', {
  init () {
    this.content = this.element.querySelector('.viewport--content')
  },
  connected () {
    this.sb = new ScrollBooster({
      viewport: this.element,
      content: this.content,
      scrollMode: 'native',
      direction: 'horizontal'
    });
    // makes sure links in scroll area aren't triggered
    this.element.addEventListener('click', this.sb.events.click, true)
  },
  disconnected () {
    this.sb.destroy()
  }
})